import { Controller } from "@hotwired/stimulus"

const MAX = 2

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.#sync()
  }

  change() {
    this.#sync()
  }

  reset() {
    this.#sync()
  }

  #sync() {
    const atLimit = this.inputTargets.filter(i => i.checked).length >= MAX
    this.inputTargets.forEach(input => {
      const label = input.closest("label")
      if (!label) return
      const disabled = atLimit && !input.checked
      label.classList.toggle("opacity-30", disabled)
      label.classList.toggle("pointer-events-none", disabled)
    })
  }
}
